import { gql } from '@apollo/client'
import { CsvSalesResponseDto } from '../../../../client/graphql'

export type CsvSalesResponse = {
	downloadURL: CsvSalesResponseDto['downloadURL']
}

export const csvSalesGql = gql`
	query csvSales($tariffCode: String, $beginEnd: [DateTime!]) {
		csvSales(tariffCode: $tariffCode, beginEnd: $beginEnd) {
			downloadURL
		}
	}
`
